<div class="categories">
  <app-page-header
    pageTitle="Categories"
    [numberOfItem]="categoryCount"
    (searchEvent)="handleSearch($event)"
    searchPlaceholder="Search by name..."
    [loading]="
      isLoading && (categoryFilter | async)?.pageNumber === 1 && !categoryCount
    "
  >
    <button class="button" (click)="toggleCategoryModal(true)" addButton>
      <img src="assets/images/add.svg" alt="+" />
      Add <span> Category</span>
    </button>
  </app-page-header>

  <div class="table-block">
    <div class="table-block__wrap">
      <table class="isLoader">
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Action</th>
        </tr>
        <ng-container
          *ngIf="
            isLoading && (categoryFilter | async)?.pageNumber === 1;
            else categorTable
          "
        >
          <ng-container *ngFor="let i of [].constructor(10)">
            <tr>
              <td>
                <app-skeleton
                  height="15px"
                  width="100px"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="100%"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <div class="table-block__action flex align-center">
                  <app-skeleton
                    height="15px"
                    width="15px"
                    margin="0"
                  ></app-skeleton>
                  <app-skeleton
                    height="15px"
                    width="15px"
                    margin="0 0 0 10px"
                  ></app-skeleton>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </table>
    </div>
  </div>
</div>

<ng-template #categorTable>
  <ng-container *ngIf="categories.length > 0; else noDataFound">
    <ng-container *ngFor="let category of categories; let i = index">
      <tr
        inViewport
        [lastElement]="categories.length === i + 1"
        (elementIsVisible)="loadMoreIfLastIndex()"
      >
        <td>{{ category.id }}</td>
        <td>
          <p>{{ category.name | titlecase }}</p>
        </td>
        <td>
          <div class="table-block__action flex align-center">
            <img
              src="assets/images/edit.svg"
              alt="Edit"
              (click)="handleEditCategory(category)"
            />
            <img
              src="assets/images/transh.svg"
              alt="transh"
              (click)="onDeleteCategory(category.id)"
            />
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="isLoading && (categoryFilter | async)?.pageNumber !== 1">
      <td>
        <app-skeleton height="15px" width="100px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100%" margin="0"></app-skeleton>
      </td>
      <td>
        <div class="table-block__action flex align-center">
          <app-skeleton height="15px" width="15px" margin="0"></app-skeleton>
          <app-skeleton
            height="15px"
            width="15px"
            margin="0 0 0 10px"
          ></app-skeleton>
        </div>
      </td>
    </tr>
  </ng-container>
</ng-template>

<ng-container *ngIf="deleteCategoryId">
  <app-confirmation-modal
    primaryButtonText="Cancel"
    secondaryButtonText="Yes"
    message="Are you sure you  want to delete this category ?"
    caption="Delete Confirmation"
    (onPrimaryButtonClick)="cancelDelete()"
    (onSecondaryButtonClick)="deleteBlog()"
    [secondaryButtonLoading]="deleteLoading"
  ></app-confirmation-modal>
</ng-container>

<ng-template #noDataFound>
  <tr>
    <td colspan="3">
      <div class="table-block__nodata">No data found</div>
    </td>
  </tr>
</ng-template>

<app-modal
  *ngIf="showCategoryModal"
  (closeModal)="toggleCategoryModal(false)"
  [modalTitle]="editCategory ? 'Edit Category' : 'Add Category'"
>
  <app-add-edit-category
    [editCategory]="editCategory"
    (onClose)="toggleCategoryModal(false)"
    (onUpdate)="handleUpdate()"
  ></app-add-edit-category>
</app-modal>
